/* eslint-disable max-classes-per-file */

export class ComponentNotFoundError extends Error {
  constructor(name) {
    super(`[VueFormily] Could not found component named '${name}', please check 'component.is'`)

    this.name = 'ComponentNotFoundError'
  }
}

export class FormItemNotFoundError extends Error {
  constructor(name) {
    super(`[VueFormily] Could not found formItem named '${name}', please check 'formItem.is'`)

    this.name = 'FormItemNotFoundError'
  }
}

export class LayoutNotFoundError extends Error {
  constructor(name) {
    super(`[VueFormily] Could not found layout named '${name}', please check 'layout.is'`)

    this.name = 'LayoutNotFoundError'
  }
}
